import type { LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';

import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const TONE_STYLES = {
  mint: 'bg-mint-soft text-mint-deep',
  amber: 'bg-status-low/15 text-status-low',
  rose: 'bg-status-out/15 text-status-out',
  sky: 'bg-sky-soft text-sky-deep',
  grape: 'bg-grape-soft text-grape-deep',
} as const;

export function StatTile({
  label,
  value,
  icon: Icon,
  to,
  tone = 'mint',
}: {
  label: string;
  value: string | number;
  icon: LucideIcon;
  to?: string;
  tone?: keyof typeof TONE_STYLES;
}) {
  const content = (
    <Card
      className={cn(
        'flex items-center gap-4 rounded-2xl border-none p-4 shadow-sm transition-transform',
        to && 'cursor-pointer hover:-translate-y-0.5 hover:shadow-md',
      )}
    >
      <div className={cn('flex h-11 w-11 shrink-0 items-center justify-center rounded-xl', TONE_STYLES[tone])}>
        <Icon className="h-5 w-5" />
      </div>
      <div className="min-w-0">
        <p className="tabular font-display text-2xl font-bold leading-tight">{value}</p>
        <p className="truncate text-xs font-medium text-muted-foreground">{label}</p>
      </div>
    </Card>
  );

  return to ? <Link to={to}>{content}</Link> : content;
}